import { memo } from "react";
import { TemplatePage } from "../../0_TemplatePage/TemplatePage";
import AdminContent from "./components/AdminContent";

function AdminPage() {
  return (
    <div className="content" sx={{ clear: "left" }}>
      <TemplatePage type={"admin"}>
        <AdminContent />
      </TemplatePage>
    </div>
  );
}

export default memo(AdminPage);
